import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '400px',
      backgroundColor: 'rgba(241, 245, 249, 1)',
      color: 'rgba(0, 0, 0, 0.6)',
      borderRadius: '8px',
      padding: '24px',
      flexGrow: 1,
      flexShrink: 0,
    },
    title: {
      fontSize: '16px',
      fontWeight: 700,
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '12px',
    },
    list: {
      paddingLeft: '15px',
    }
  }
))
